import {WebHookEditContainerV2} from './WebHookEditContainerV2';
import {useEffect, useState} from 'react';
import PulsoidClient from '../../../../PulsoidClient';
import {Loader} from '../../../../system/Loader/Loader';
import * as React from 'react';
import {WebHookEditContainer} from './WebHookEditContainer';
import {MetaDixperIntegrationId, MetaVoicemodeIntegrationId} from '../../utils';
import {VoicemodeIntegration} from '../integration/voicemod/VoicemodeIntegration';
import {DixperIntegration} from '../integration/dixper/DixperIntegration';

export const WebHookEditRouter = (props) => {
  let v2IntegrationMetaId = ['50b602a8-bb03-4929-8d2c-75986741fb62'];
  const [isV2Integration, setIsV2Integration] = useState(null);
  const [metaId, setMetaId] = useState(null);
  useEffect(() => {
    new PulsoidClient().getWebHook(props.match.params.id).then((res) => {
      setMetaId(res.metaId);
      setIsV2Integration(v2IntegrationMetaId.includes(res.metaId));
    });
  }, []);

  if (metaId === MetaVoicemodeIntegrationId) {
    return <VoicemodeIntegration {...props} />;
  } else if (metaId === MetaDixperIntegrationId) {
    return <DixperIntegration {...props} />;
  } else {
    if (isV2Integration != null) {
      if (isV2Integration) {
        return <WebHookEditContainerV2 {...props} />;
      } else {
        return <WebHookEditContainer {...props} />;
      }
    } else {
      return (
        <Loader loading={true} description={'Loading integration config'} />
      );
    }
  }
};
